import { TRUSTPILOT_REVIEW_COUNT } from "constants/configConstants";

const addCommasToNumber = (num: any) => {
  if (!__CLIENT__) return TRUSTPILOT_REVIEW_COUNT;
  if (num === undefined || num === null) {
    return TRUSTPILOT_REVIEW_COUNT;
  }

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default addCommasToNumber;
